/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  SummaryText,
  SummaryText$inboundSchema,
  SummaryText$Outbound,
  SummaryText$outboundSchema,
} from "./summarytext.js";

export type ResponseReasoningSummaryPartAddedEvent = {
  type: "response.reasoning_summary_part.added";
  sequenceNumber: number;
  itemId: string;
  outputIndex: number;
  summaryIndex: number;
  part: SummaryText;
};

/** @internal */
export const ResponseReasoningSummaryPartAddedEvent$inboundSchema: z.ZodType<
  ResponseReasoningSummaryPartAddedEvent,
  z.ZodTypeDef,
  unknown
> = z.object({
  type: z.literal("response.reasoning_summary_part.added"),
  sequence_number: z.number().int(),
  item_id: z.string(),
  output_index: z.number().int(),
  summary_index: z.number().int(),
  part: SummaryText$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "sequence_number": "sequenceNumber",
    "item_id": "itemId",
    "output_index": "outputIndex",
    "summary_index": "summaryIndex",
  });
});
/** @internal */
export type ResponseReasoningSummaryPartAddedEvent$Outbound = {
  type: "response.reasoning_summary_part.added";
  sequence_number: number;
  item_id: string;
  output_index: number;
  summary_index: number;
  part: SummaryText$Outbound;
};

/** @internal */
export const ResponseReasoningSummaryPartAddedEvent$outboundSchema: z.ZodType<
  ResponseReasoningSummaryPartAddedEvent$Outbound,
  z.ZodTypeDef,
  ResponseReasoningSummaryPartAddedEvent
> = z.object({
  type: z.literal("response.reasoning_summary_part.added"),
  sequenceNumber: z.number().int(),
  itemId: z.string(),
  outputIndex: z.number().int(),
  summaryIndex: z.number().int(),
  part: SummaryText$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    sequenceNumber: "sequence_number",
    itemId: "item_id",
    outputIndex: "output_index",
    summaryIndex: "summary_index",
  });
});

export function responseReasoningSummaryPartAddedEventToJSON(
  responseReasoningSummaryPartAddedEvent:
    ResponseReasoningSummaryPartAddedEvent,
): string {
  return JSON.stringify(
    ResponseReasoningSummaryPartAddedEvent$outboundSchema.parse(
      responseReasoningSummaryPartAddedEvent,
    ),
  );
}
export function responseReasoningSummaryPartAddedEventFromJSON(
  jsonString: string,
): SafeParseResult<ResponseReasoningSummaryPartAddedEvent, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      ResponseReasoningSummaryPartAddedEvent$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ResponseReasoningSummaryPartAddedEvent' from JSON`,
  );
}
